var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 16,
    transform: "matrix(-1 -1.74846e-07 -1.74846e-07 1 16 16)",
    fill: "#00B3AE",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1268 15.5206L25.8398 16.2217L25.1268 16.9227L17.8872 24.0406C17.4934 24.4278 16.8549 24.4278 16.461 24.0406C16.0672 23.6534 16.0672 23.0256 16.461 22.6384L21.9704 17.2217L4.86569 17.2217C4.3134 17.2217 3.86569 16.7739 3.86569 16.2217C3.86569 15.6694 4.3134 15.2217 4.86569 15.2217L21.9704 15.2217L16.461 9.80488C16.0672 9.41768 16.0672 8.7899 16.461 8.4027C16.8549 8.0155 17.4934 8.0155 17.8872 8.4027L25.1268 15.5206Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowRight);
export default __webpack_public_path__ + "static/media/nav_arrow_right.0b9ee9ac5e4c7f34b82caa4a66d8238e.svg";
export { ForwardRef as ReactComponent };